import { schemes } from "@zeal/common";
import { z } from "zod";

export const createPaycardSsnInquiryResponseSchema = z.object({
  inquiryId: z.string(),
});

export const createEmployeePaycardSsnInquirySchema = z.object({
  workerId: schemes.mongoObjectId(),
});

export type TCreateEmployeePaycardSsnInquiryRequest = z.infer<
  typeof createEmployeePaycardSsnInquirySchema
>;

export type TCreatePaycardSsnInquiryResponse = z.infer<
  typeof createPaycardSsnInquiryResponseSchema
>;
